import { render, staticRenderFns } from "./erikoistuva-arviointilomake-vastuuhenkilon-arvio.vue?vue&type=template&id=9c430cc0&"
import script from "./erikoistuva-arviointilomake-vastuuhenkilon-arvio.vue?vue&type=script&lang=ts&"
export * from "./erikoistuva-arviointilomake-vastuuhenkilon-arvio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports